import React from "react";
import {
  List,
  Typography,
  Space,
  Row,
  Col,
  Button,
  Popconfirm,
  Empty,
} from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const { Text } = Typography;

const CalibrationHistory = ({ data, editable, deleteDoc }) => {
  return data.length > 0 ? (
    <List
      itemLayout="vertical"
      dataSource={data}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            description={
              <Row gutter={[8, 0]} align="middle">
                <Col xs={24} sm={12} md={4}>
                  <Space>
                    <CalendarOutlined />
                    <Text>{dayjs(item.date).format("YYYY-MM-DD")}</Text>
                  </Space>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Space>
                    {item.certLink ? (
                      <a
                        href={item.certLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.fileName || "Certificate"} <DownloadOutlined />
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </Space>
                </Col>
                <Col xs={24} sm={24} md={14}>
                  <Text
                    type="secondary"
                    strong
                    style={{ display: "block", marginBottom: 4 }}
                  >
                    Upload Information
                  </Text>
                  <Space>
                    <CalendarOutlined />
                    <Text type="secondary">
                      {dayjs(item.uploadDate).format("YYYY-MM-DD")}
                    </Text>
                    <UserOutlined />
                    <Text type="secondary">{`${item.uploadedBy.firstName} ${item.uploadedBy.lastName} (${item.uploadedBy.initials})`}</Text>
                  </Space>
                </Col>
                {editable && (
                  <Col
                    xs={24}
                    sm={24}
                    md={8}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Popconfirm
                      title="Are you sure you want to remove this document?"
                      onConfirm={() => deleteDoc(item.id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="text" danger>
                        Remove
                      </Button>
                    </Popconfirm>
                  </Col>
                )}
              </Row>
            }
          />
        </List.Item>
      )}
    />
  ) : (
    <Empty description="No Calibration History Available" />
  );
};

export default CalibrationHistory;
